import { Utils } from '@genial/utils';

import {
  ReturnTypeOf_ObterClube,
  ReturnTypeOf_ObterDatasClubes,
  ReturnTypeOf_ProdutosObterProdutosDisponiveis,
} from '../external/types';
import {
  ClubsDateEntityNormalized,
  ClubsDetailsEntityNormalized,
  ClubsEntityNormalized,
} from '../types';

export const normalizeClubs = (
  data: ReturnTypeOf_ProdutosObterProdutosDisponiveis
): ClubsEntityNormalized[] => {
  if (!data || !data.ativosClubes) {
    return [];
  }

  try {
    return data.ativosClubes.map((club) => {
      const now = new Date();
      const cutoffTime = new Date(now);

      if (club.horaLimite) {
        const [hours, minutes, seconds] = club.horaLimite.split(':').map(Number);
        cutoffTime.setHours(hours || 0, minutes || 0, seconds || 0);
      }

      return {
        clubId: club.idProdutoClube,
        fundId: club.idClubeFundo,
        clientId: club.idCliente,
        clubNameNormalized: club.rsClube.trim(),
        managerNameNormalized: club.nmGestor.trim(),
        cutoffTime,
        minimumApplication: club.aplicacaoMinima,
        minimumApplicationNormalized: Utils.Mask.Money(club.aplicacaoMinima),
        minimumMovement: club.movimentacaoMinima,
        minimumMovementNormalized: Utils.Mask.Money(club.movimentacaoMinima),
        cutoffTimeNormalized: club.horaLimite,
        applicationQuotationDays: club.nrDiasAplicacaoCotizacao,
        redemptionQuotationDays: club.nrDiasResgateCotizacao,
        redemptionSettlementDays: club.nrDiasResgateLiquidacao,
      };
    });
  } catch (_error) {
    return [];
  }
};

export const normalizeClubsDetails = (
  clubData: ReturnTypeOf_ObterClube,
  datesData: ReturnTypeOf_ObterDatasClubes
): ClubsDetailsEntityNormalized => {
  if (!clubData) {
    return {} as ClubsDetailsEntityNormalized;
  }

  const now = new Date();
  const cutoffTime = new Date(now);

  if (clubData.horaLimite) {
    const [hours, minutes, seconds] = clubData.horaLimite.split(':').map(Number);
    cutoffTime.setHours(hours || 0, minutes || 0, seconds || 0);
  }

  const quotationDate = new Date(now);
  quotationDate.setDate(quotationDate.getDate() + (clubData.nrDiasAplicacaoCotizacao || 0));

  const settlementDate = new Date(now);
  settlementDate.setDate(settlementDate.getDate() + (clubData.nrDiasResgateLiquidacao || 0));

  let riskLevel = 0;

  if (clubData.perfilRisco === 'ARROJADO') {
    riskLevel = 5;
  } else if (clubData.perfilRisco === 'MODERADO') {
    riskLevel = 4;
  } else if (clubData.perfilRisco === 'CONSERVADOR') {
    riskLevel = 1.5;
  }

  return {
    clubId: clubData.idProdutoClube,
    fundId: clubData.idClubeFundo,
    clientId: clubData.idCliente,
    clubNameNormalized: clubData.rsClube.trim(),
    managerNameNormalized: clubData.nmGestor.trim(),
    cutoffTime,
    minimumApplication: clubData.aplicacaoMinima,
    minimumApplicationNormalized: Utils.Mask.Money(clubData.aplicacaoMinima),
    minimumMovement: clubData.movimentacaoMinima,
    minimumMovementNormalized: Utils.Mask.Money(clubData.movimentacaoMinima),
    cutoffTimeNormalized: clubData.horaLimite,
    applicationQuotationDays: clubData.nrDiasAplicacaoCotizacao,
    redemptionQuotationDays: clubData.nrDiasResgateCotizacao,
    redemptionSettlementDays: clubData.nrDiasResgateLiquidacao,
    quotationDate: new Date(datesData.dataCotizacao),
    quotationDateNormalized: Utils.Mask.DateFormat(new Date(datesData.dataCotizacao), 'dd/MM/yyyy'),
    settlementDate: new Date(datesData.dataLiquidacao),
    settlementDateNormalized: Utils.Mask.DateFormat(
      new Date(datesData.dataLiquidacao),
      'dd/MM/yyyy'
    ),
    riskRatingLevelNormalized: riskLevel,
    riskRatingNormalized: clubData.perfilRisco,
  };
};

export const normalizeClubsDate = (
  data: ReturnTypeOf_ObterDatasClubes
): ClubsDateEntityNormalized => {
  if (!data) {
    return {} as ClubsDateEntityNormalized;
  }

  return {
    quotationDate: new Date(data.dataCotizacao),
    quotationDateNormalized: Utils.Mask.DateFormat(new Date(data.dataCotizacao), 'dd/MM/yyyy'),
    settlementDate: new Date(data.dataLiquidacao),
    settlementDateNormalized: Utils.Mask.DateFormat(new Date(data.dataLiquidacao), 'dd/MM/yyyy'),
  };
};
